<template>
    <v-menu
        v-model="mostrar"
        :close-on-content-click="false">
        <template
            v-slot:activator="{ on, attrs }">
            <v-btn
                icon
                v-bind="attrs"
                v-on="on">
                <v-icon>
                    mdi-dots-vertical
                </v-icon>
            </v-btn>
        </template>
        <v-list nav dense>
          <v-list-item :to="{ name: 'auditoriaInformes', params: { idAuditoria: auditoria.id } }">
            <v-list-item-icon>
              <v-icon>mdi-file-document-alert-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                Informes
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-icon>
              <v-chip small>
                {{ auditoria.informes.length }}
              </v-chip>
            </v-list-item-icon>
          </v-list-item>
          <v-list-item
            v-if="mixValidaScopesActions(2)"
            @click="agregarInforme"
            link>
            <v-list-item-icon>
              <v-icon>
                mdi-file-plus-outline
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                Agregar Informe
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider class="my-1"></v-divider>
          <v-list-item
            v-if="mixValidaScopesActions(2)"
            @click="descargarExpediente"
            link>
            <v-list-item-icon>
              <v-icon>
                mdi-cloud-download-outline
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                Descargar Expediente
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider class="my-1"></v-divider>
          <v-list-item
          v-if="mixValidaScopesActions(2)"
            @click="editar"
            link>
            <v-list-item-icon>
              <v-icon>
                mdi-pencil
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                Editar
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
          v-if="mixValidaScopesActions(3)"
          @click="borrar"
            link>
            <v-list-item-icon>
              <v-icon>
                mdi-delete
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                Eliminar
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <!--
          <v-list-item
          v-if="mixValidaScopesActions(2)"
          :disabled="auditoria.fileData && auditoria.fileData !==''? false:true"
          @click="verPdf"
            link>
            <v-list-item-icon>
              <v-icon>
                mdi-file-pdf-box
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                VerPdf
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          -->
        </v-list>
    </v-menu>
</template>

<script>
import eventBus from '@/helpers/eventBus';

export default {
  name: 'OpcionesListadoAuditorias',
  props: {
    auditoria: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      mostrar: false,
    };
  },
  methods: {
    editar() {
      eventBus.$emit('editar-auditoria', this.auditoria);
    },
    borrar() {
      eventBus.$emit('eliminar-auditoria', this.auditoria);
    },
    verPdf() {
      eventBus.$emit('ver-pdf-auditorias', this.auditoria);
    },
    agregarInforme() {
      eventBus.$emit('agregar-auditoria-informe', this.auditoria);
    },
    descargarExpediente() {
      eventBus.$emit('descargar-auditoria-expediente', this.auditoria);
    },
  },
};
</script>

<style lang="scss">

</style>
